// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"592":"group-user","638":"group-admin"}[chunkId] + "." + {"592":"eed39e5c","638":"b5f09cc4"}[chunkId] + ".css";
};